import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card shadow my-3" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table table-hover align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", { class: "thead-loupey" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      width: "20px"
    }),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      width: "35px"
    }),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "Subject"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Timestamp"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      width: "20px"
    })
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"m-3\"><nav aria-label=\"\"><div class=\"pagination pagination-sm justify-content-end\"><div class=\"page-item\"><a class=\"page-link\" href=\"#\">Previous</a></div><div class=\"page-item\"><a class=\"page-link\" href=\"#\">1</a></div><div class=\"page-item\"><a class=\"page-link\" href=\"#\">2</a></div><div class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></div><div class=\"page-item\"><a class=\"page-link\" href=\"#\">Next</a></div></div></nav></div>", 1)
const _hoisted_7 = { class: "d-flex align-items-center justify-content-end gap-3" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_template_table_row = _resolveComponent("template-table-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification) => {
              return (_openBlock(), _createBlock(_component_template_table_row, {
                key: notification.id,
                onToggleSelected: ($event: any) => (notification.selected = !notification.selected),
                onMarkRead: ($event: any) => (notification.read = true),
                selected: notification.selected,
                id: notification.id,
                subject: notification.subject,
                timestamp: notification.timestamp,
                message: notification.message,
                read: notification.read
              }, null, 8, ["onToggleSelected", "onMarkRead", "selected", "id", "subject", "timestamp", "message", "read"]))
            }), 128))
          ])
        ])
      ]),
      _hoisted_6
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#filter-bar-content" }, [
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("span", { class: "badge rounded-pill bg-primary" }, _toDisplayString(_ctx.numSelected), 513), [
          [_vShow, _ctx.numSelected > 0]
        ]),
        _createElementVNode("button", {
          disabled: _ctx.numSelected == 0,
          type: "button",
          class: "btn btn-sm btn-primary",
          "data-bs-toggle": "modal",
          "data-bs-target": "#inviteUserModal"
        }, " Mark Read ", 8, _hoisted_8)
      ])
    ]))
  ]))
}